module.exports = __webpack_public_path__ + "assets/img/personAll.aa7ea425.png";